import React from "react";
import ContactForm from "./ContactForm";
import Map from "./Map";
import './ContactMap.css'

const ContactMap = () => {
  return (
    <div>
      <h2 className="text-center mt-5 text-4xl font-bold">Contact</h2>

      <div className=" w-[90%] mx-auto  contactmap">
        <ContactForm />
        <Map />
      </div>
    </div>
  );
};

export default ContactMap;


